/** Where a customer writes when the application itself cannot help them. */
export const SUPPORT_EMAIL = "hello@ceedero.com";
